var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCartIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.51512 19.9972H26.284C27.8083 19.9972 28.5704 19.9972 29.1771 19.713C29.7116 19.4626 30.1607 19.0607 30.4685 18.5571C30.818 17.9855 30.9021 17.228 31.0705 15.7131L31.9509 7.78935C32.0023 7.32662 32.028 7.09526 31.9536 6.91618C31.8882 6.75891 31.7715 6.62845 31.6224 6.54614C31.4526 6.45241 31.2198 6.45241 30.7543 6.45241H5.76264M2 1.9375H3.87886C4.27711 1.9375 4.47624 1.9375 4.63203 2.01324C4.76917 2.07991 4.88283 2.18668 4.95793 2.3194C5.04323 2.47016 5.05565 2.6689 5.0805 3.06637L6.44436 24.8882C6.4692 25.2856 6.48162 25.4844 6.56693 25.6351C6.64203 25.7679 6.75568 25.8746 6.89283 25.9413C7.04862 26.017 7.24774 26.017 7.64599 26.017H27.5845M10.2773 31.2844H10.2924M23.8221 31.2844H23.8371M11.0298 31.2844C11.0298 31.7 10.6929 32.0369 10.2773 32.0369C9.86175 32.0369 9.52486 31.7 9.52486 31.2844C9.52486 30.8688 9.86175 30.5319 10.2773 30.5319C10.6929 30.5319 11.0298 30.8688 11.0298 31.2844ZM24.5746 31.2844C24.5746 31.7 24.2377 32.0369 23.8221 32.0369C23.4065 32.0369 23.0696 31.7 23.0696 31.2844C23.0696 30.8688 23.4065 30.5319 23.8221 30.5319C24.2377 30.5319 24.5746 30.8688 24.5746 31.2844Z",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartIcon);
export default __webpack_public_path__ + "static/media/cart-icon.3653f124.svg";
export { ForwardRef as ReactComponent };